import React from 'react';
import './index.pc.scss';

import PcFinishContact from 'components/molecules/PcFinishContact';
import PcBasicTemplate from 'components/templates/PcBasicTemplate';

import { ADD_THANKS_TEXT } from 'utils/constant';

const PresentPC = ({
  onClickMainButton,
}) => (
  <div className="AddThanks PC">
    <PcBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
    >
      <span>
        <PcFinishContact
          info={ADD_THANKS_TEXT.information}
        />
      </span>
    </PcBasicTemplate>
  </div>

);

export default PresentPC;